import { SearchOperators } from '@seahorse/domain';
import { FilterMatchMode } from 'primeng/api';

export const FILTER_OPERATORS: Record<string, SearchOperators> = {
  [FilterMatchMode.EQUALS]: SearchOperators.Equals,
  [FilterMatchMode.NOT_EQUALS]: SearchOperators.NotEquals,
  [FilterMatchMode.CONTAINS]: SearchOperators.Contains,
  [FilterMatchMode.STARTS_WITH]: SearchOperators.StartsWith,
  [FilterMatchMode.ENDS_WITH]: SearchOperators.EndsWith,
  [FilterMatchMode.LESS_THAN]: SearchOperators.LesserThan,
  [FilterMatchMode.GREATER_THAN]: SearchOperators.GreaterThan,
  [FilterMatchMode.DATE_IS]: SearchOperators.Equals,
  [FilterMatchMode.DATE_IS_NOT]: SearchOperators.NotEquals,
  [FilterMatchMode.DATE_BEFORE]: SearchOperators.LesserThan,
  [FilterMatchMode.DATE_AFTER]: SearchOperators.GreaterThan,
};
